import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Card, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Controller } from 'react-hook-form';
import { RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/form-provider';
import RHFRadioGroupLegacy from 'src/components/hook-form/rhf-radio-group-legacy';
import { paths } from 'src/routes/paths';
import { NavigateFunction } from 'react-router-dom';

type Props = {
  methods: any;
  control: any;
  isEdit: boolean;
  isSubmitting: boolean;
  statusOptions: string[];
  statuslabel: string[];
  onSubmit: VoidFunction;
  navigate: NavigateFunction;
};

export default function FairForm({
  methods,
  control,
  isEdit,
  isSubmitting,
  statuslabel,
  statusOptions,
  onSubmit,
  navigate,
}: Props) {
  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Card>
        <Stack spacing={2} p={4}>
          <RHFTextField name="name" label="Nome" />
          <Controller
            name="startDate"
            control={control}
            render={({ field, fieldState }) => (
              <DatePicker
                sx={{ flex: 1 }}
                closeOnSelect
                label="Data de Início"
                slotProps={{
                  textField: {
                    error: !!fieldState.error,
                    helperText: fieldState.error?.message,
                  },
                  day: {
                    sx: {
                      '&.MuiPickersDay-root.Mui-selected': {
                        backgroundColor: 'primary.main',
                      },
                    },
                  },
                }}
                value={field.value}
                onChange={(date) => {
                  if (date) {
                    const normalizedDate = new Date(
                      date.getFullYear(),
                      date.getMonth(),
                      date.getDate()
                    );
                    field.onChange(normalizedDate);
                  } else {
                    field.onChange(null);
                  }
                }}
              />
            )}
          />
          <Controller
            name="endDate"
            control={control}
            render={({ field, fieldState }) => (
              <DatePicker
                sx={{ flex: 1 }}
                closeOnSelect
                label="Data de Fim"
                slotProps={{
                  textField: {
                    error: !!fieldState.error,
                    helperText: fieldState.error?.message,
                  },
                  day: {
                    sx: {
                      '&.MuiPickersDay-root.Mui-selected': {
                        backgroundColor: 'primary.main',
                      },
                    },
                  },
                }}
                value={field.value}
                onChange={(date) => {
                  if (date) {
                    const normalizedDate = new Date(
                      date.getFullYear(),
                      date.getMonth(),
                      date.getDate()
                    );
                    field.onChange(normalizedDate);
                  } else {
                    field.onChange(null);
                  }
                }}
              />
            )}
          />
          <Stack>
            <Typography>Status:</Typography>
            <RHFRadioGroupLegacy
              name="status"
              options={statusOptions}
              getOptionLabel={statuslabel}
            />
          </Stack>
          <Stack justifyContent='flex-end' direction='row' spacing={2}>
            <Button onClick={() => navigate(paths.dashboard.fairList)}>
              Voltar
            </Button>
            <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
              {!isEdit ? 'Cadastrar Feira' : 'Editar Feira'}
            </LoadingButton>
          </Stack>
        </Stack>
      </Card>
    </FormProvider>
  );
}
